export default "/iconSessionNote.svg";